<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

const MIME_MAP = {
  image: "image/jpeg,image/jpg,image/png,image/gif,image/webp,image/svg+xml,image/bmp,image/tiff",
  pdf: "application/pdf",
  word: "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  excel: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  powerpoint: "application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation",
  text: "text/plain",
  zip: "application/zip,application/x-rar-compressed",
};

export default {
  name: "MediaUploader",
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    uploadUrl: {
      type: String,
      required: true,
    },
    onlyImages: {
      type: Boolean,
      default: false,
    },
    type: {
      type: [String, Array],
      default: null,
    },
    extension: {
      type: [String, Array],
      default: null,
    },
    mimeType: {
      type: [String, Array],
      default: null,
    },
    maxFilesize: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    dropzoneOptions() {
      const token = localStorage.getItem("authToken");
      return {
        url: this.uploadUrl,
        method: "post",
        thumbnailWidth: 120,
        maxFilesize: this.maxFilesize,
        paramName: "file",
        uploadMultiple: false,
        parallelUploads: 1,
        headers: {
          Authorization: "Bearer " + token,
        },
        addRemoveLinks: true,
        acceptedFiles: this.acceptedFiles,
      };
    },
    acceptedFiles() {
      if (this.mimeType) {
        const types = Array.isArray(this.mimeType) ? this.mimeType : [this.mimeType];
        return types.join(",");
      }
      if (this.onlyImages) {
        return MIME_MAP.image;
      }
      if (this.type) {
        const types = Array.isArray(this.type) ? this.type : [this.type];
        return types.map((t) => MIME_MAP[t]).filter(Boolean).join(",");
      }
      return null;
    },
  },
  methods: {
    onSuccess(file, response) {
      const media = response?.data?.data || response?.data;
      this.$emit("uploaded", media);
    },
    onError(file, message) {
      this.$emit("error", message);
    },
  },
};
</script>

<template>
  <vue-dropzone
    ref="mediaDropzone"
    id="media-uploader-dropzone"
    :options="dropzoneOptions"
    @vdropzone-success="onSuccess"
    @vdropzone-error="onError"
  />
</template>
